import cropSampling from "./cropSampling";
import lang from "../../lib/appfuse-react/core/lang";

const cropSamplingService = [{
    matcher: 'cropSampling',
    reply: config => {
        if(config.method==='post') {
            return [200, cropSampling[0]];
        } else {
            const {predicate} = config.params;
            let data;
            const selector = predicate?.node()?.selector?.();
            const children = predicate?.node()?.children?.();
            if(lang.isNotEmpty(selector)) {
                const value = predicate.node().expectation();
                if(lang.isEmpty(value)) {
                    return [200, cropSampling];
                }
                if(selector==='farmerNo' || selector==='farmerName') {
                    const regexp = new RegExp(value.replaceAll('*', '.*'));
                    data = cropSampling.filter(crop => regexp.test(crop[selector]));
                } else if(selector==='createdOnStart') {
                    data = cropSampling.filter(crop => crop.createdOn >= value);
                } else if(selector==='createdOnEnd') {
                    data = cropSampling.filter(crop => crop.createdOn <= value);
                }
            } else if(lang.isNotEmpty(children)) {
                let tmp = cropSampling;
                for(let child of children) {
                    const value = child.expectation();
                    if(lang.isEmpty(value)) {
                        continue;
                    }
                    const selector = child.selector();
                    if(selector==='farmerNo' || selector==='farmerName') {
                        const regexp = new RegExp(value.replaceAll('*', '.*'));
                        tmp = tmp.filter(crop => regexp.test(crop[selector]));
                    } else if(selector==='createdOnStart') {
                        tmp = tmp.filter(crop => crop.createdOn >= value);
                    } else if(selector==='createdOnEnd') {
                        tmp = tmp.filter(crop => crop.createdOn <= value);
                    }
                }
                data = tmp;
            } else {
                data = cropSampling;
            }
            return [200, data];
        }
    }
}, {
    matcher: /cropSampling\/(.*)/,
    reply: config => {
        const id = /cropSampling\/(.*)/.exec(config.url)[1];
        const data = cropSampling.find(crop => crop.id===id);
        return [200, data];
    }
}];

export default cropSamplingService;